var _path, _path2, _path3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinkPurpleGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FF4081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#9C27B0"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75,40 125,120 25,120 Z",
    fill: "#FF4081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150,40 200,120 100,120 Z",
    fill: "#AB47BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225,40 275,120 175,120 Z",
    fill: "#9C27B0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 180,
    fontFamily: "Futura, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#333333",
    textAnchor: "middle"
  }, "VALLEY TECH")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.cf14132e6cfbd5630cb0365156398a21.svg";
export { ForwardRef as ReactComponent };